import { render } from "./UserQuestionnaires.vue?vue&type=template&id=79e43bee"
import script from "./UserQuestionnaires.vue?vue&type=script&lang=js"
export * from "./UserQuestionnaires.vue?vue&type=script&lang=js"

import "./UserQuestionnaires.vue?vue&type=style&index=0&id=79e43bee&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__